import Component from 'vue-class-component';

// TAB: Allow classes to receive Vue Router callback methods
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate'
]);
